import React from 'react';
import classNames from 'classnames';
import { useExperiments } from 'components/Experiment/useExperiments';
import { AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT } from 'constants/monetateExperiments';
import { Container, ContainerProps } from '@johnlewispartnership/wtr-content-component-library';
import ExperienceFragment from 'components/ExperienceFragment';
import { getOnboardingExperienceFragmentKey } from 'redux/fetchers/onboarding-experience-fragment';

/**
 * We remove elementId so we don't end up with duplicate IDs in the DOM
 * as this component could be rendered more than once due to mobile/desktop versions co-existing.
 */
const OnboardingContent = ({ elementId, ...containerProps }: ContainerProps) => {
  const { getDecisionById } = useExperiments();
  const { variant, payload } = getDecisionById(AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.experiment);

  if (!variant || variant === AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.variant.default) {
    return null;
  }

  const experienceFragmentKey = getOnboardingExperienceFragmentKey(variant, payload);

  return experienceFragmentKey ? (
    <div
      // This wrapper is required so we continue to honour the main container's layout/breakpoints
      className={classNames(containerProps.breakpointClasses)}
      data-testid="onboarding-experience-fragment-wrapper"
    >
      <ExperienceFragment experienceFragmentKey={experienceFragmentKey} locationName="root" />
    </div>
  ) : (
    <Container {...containerProps} />
  );
};

export default OnboardingContent;
